import { Box, getThemeColor, getThemeSpacing } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Table = styled(Box)`
  border-radius: 16px;
  border: 1px solid ${({ theme }) => getThemeColor('grey_4', theme)};
  width: 100%;
  overflow: hidden;
  flex-direction: column;
`

export const HeaderRow = styled(Box)`
  background-color: ${({ theme }) => getThemeColor('grey_5', theme)};
  width: 100%;
  min-height: 72px;
  align-items: center;
  padding: ${({ theme }) => getThemeSpacing(2, theme)};
  gap: ${({ theme }) => getThemeSpacing(2, theme)};
`

export const Row = styled(Box)`
  background-color: ${({ theme }) => getThemeColor('white', theme)};
  width: 100%;
  min-height: 72px;
  align-items: center;
  padding: ${({ theme }) => getThemeSpacing(2, theme)};
  gap: ${({ theme }) => getThemeSpacing(2, theme)};
  border-top: 1px solid ${({ theme }) => getThemeColor('grey_4', theme)};
`
